import * as actionTypes from "./actionTypes";
import paymentService from "services/paymentService";
import orderService from "services/orderService";
import voucherService from "services/voucherService";
import timeUtils from "utils/time";
import loginService from "services/loginService";

const successFetchingCarts = cards => {
  return {
    type: actionTypes.TEAM_VOUCHER_SUCCESS_FETCHING_CARDS,
    payload: cards
  };
};

export const closeModalPlacedOrder = () => {
  return {
    type: actionTypes.TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER,
    payload: false
  };
};

const openModalPlacedOrder = () => {
  return {
    type: actionTypes.TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER,
    payload: true
  };
};

const successPlaceOrder = data => {
  return {
    type: actionTypes.TEAM_VOUCHER_SUCCESS_PLACE_ORDER,
    payload: { idOrder: data.id, idBusinessRestaurant: data.restaurant.id }
  };
};

const teamVoucherResetState = () => {
  return {
    type: actionTypes.TEAM_VOUCHER_RESET_STATE
  };
};

const paymentOrder = payload => {
  return dispatch => {
    paymentService
      .pay(payload)
      .then(data => {
        if (data.success) {
          dispatch(openModalPlacedOrder());
        } else {
          dispatch(
            openModalError({
              errorMessage: "There was a problem with your card. Please delete it and try again.",
              errorType: "pay-order"
            })
          );
        }
      })
      .catch(error =>
        dispatch(
          openModalError({
            errorMessage: error.message,
            errorType: "pay-order"
          })
        )
      );
  };
};

const successValidTeamVouchersRequest = vouchers => {
  return {
    type: actionTypes.TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER,
    payload: !!vouchers
      ? vouchers.map(v => {
          v.expiryDate = timeUtils.dateArrayToDate(v.expiryDate);
          return v;
        })
      : undefined
  };
};

const teamVoucherSetCampaignRate = campaignRateCC => {
  return {
    type: actionTypes.TEAM_VOUCHER_SET_CAMPAIGN_RATE,
    payload: campaignRateCC
  };
};

const teamVoucherSetPayInfo = payInfo => {
  return {
    type: actionTypes.TEAM_VOUCHER_SET_PAY_INFO,
    payload: payInfo
  };
};

const openModalError = errorObject => {
  return {
    type: actionTypes.TEAM_VOUCHER_OPEN_MODAL_ERROR,
    payload: errorObject
  };
};

export const closeModalError = () => {
  return {
    type: actionTypes.TEAM_VOUCHER_CLOSE_MODAL_ERROR,
    payload: false
  };
};

export const teamVoucherSetOrder = order => {
  return {
    type: actionTypes.TEAM_VOUCHER_SET_ORDER,
    payload: order
  };
};

export const teamVoucherFetchingCards = () => {
  return dispatch => {
    paymentService
      .getCards()
      .then(data => dispatch(successFetchingCarts(data)))
      .catch(error => console.error(error));
  };
};

export const customerExist = (emailList, newOption) => {
  return dispatch => {
    loginService
      .preLogin({ email: newOption.value })
      .then(data => {
        if (!!data.userAlreadyRegistered) {
          return;
        }

        if (data.hasRelatedBusiness) {
          dispatch(
            openModalError({
              errorMessage: `${newOption.value} is not registered in LunchTeam, do you want to register this user?`,
              errorType: "invalid-team-voucher",
              errorObject: newOption
            })
          );
        } else {
          dispatch(
            openModalError({
              errorMessage: `We can't identify any business related with ${newOption.value}. We will remove this email from team voucher email list and if you have sure that this email is correct, please, contact us in our support.`,
              errorType: "not-accepted-invalid-team-voucher",
              errorObject: newOption
            })
          );
        }
      })
      .catch(error => {
        dispatch(
          openModalError({
            errorMessage: `We can't identify any business related with ${newOption.value}. We will remove this email from team voucher email list and if you have sure that this email is correct, please, contact us in our support.`,
            errorType: "not-accepted-invalid-team-voucher",
            errorObject: newOption
          })
        );
      });
  };
};

export const verifyUnregisteredEmails = (emailList, newOption) => {
  return dispatch => {
    loginService
      .preLogin({ email: newOption.value })
      .then(data => {
        if (data.userAlreadyRegistered && data.hasRelatedBusiness) {
          return "REGISTERED";
        }
        if (data.hasRelatedBusiness && !data.userAlreadyRegistered) {
          return "NOT REGISTERED";
          /* dispatch(
            openModalError({
              errorMessage: `${newOption.value} is not registered in LunchTeam, do you want to register this user?`,
              errorType: "invalid-team-voucher",
              errorObject: newOption
            })
          ); */
        } else {
          /* dispatch(
            openModalError({
              errorMessage: `We can't identify any business related with ${newOption.value}. We will remove this email from team voucher email list and if you have sure that this email is correct, please, contact us in our support.`,
              errorType: "not-accepted-invalid-team-voucher",
              errorObject: newOption
            })
          );
          return null; */
        }
      })
      .catch(error => {
        dispatch(
          openModalError({
            errorMessage: `We can't identify any business related with ${newOption.value}. We will remove this email from team voucher email list and if you have sure that this email is correct, please, contact us in our support.`,
            errorType: "not-accepted-invalid-team-voucher",
            errorObject: newOption
          })
        );
      });
  };
};

export const placeOrderAndGoToAddNewCard = (order, payInfo, history) => {

  return dispatch => {
    orderService
      .placeOrder(order)
      .then(data => {
        dispatch(successPlaceOrder(data));
        dispatch(teamVoucherSetPayInfo(payInfo));
        history.push("/Menu/checkout");
      })
      .catch(error =>
        dispatch(
          openModalError({
            errorMessage: error.message,
            errorType: "place-order"
          })
        )
      );
  };
};

export const closeModalPlacedOrderAndRedirect = history => dispatch => {
  dispatch(teamVoucherResetState());
  history.replace("/TeamVoucher");
};

export const placeOrderAndPay = (order, payInfo) => {
  return dispatch => {
    orderService
      .placeOrder(order)
      .then(data => {
        let payInfoUpdated = {
          ...payInfo,
          idOrder: data.id
        };
        dispatch(successPlaceOrder(data));
        dispatch(paymentOrder(payInfoUpdated));
      })
      .catch(error =>
        dispatch(
          openModalError({
            errorMessage: error.message,
            errorType: "place-order"
          })
        )
      );
  };
};

export const fetchValidTeamVouchers = () => {
  return dispatch => {
    voucherService
      .availableTeamVoucher()
      .then(vouchers => {
        dispatch(successValidTeamVouchersRequest(vouchers));
      })
      .catch(error =>
        console.error("When try to fetch available team vouchers: ", error)
      );
  };
};

const byChargeTypeCC = campaignRate => campaignRate.chargeType === "C";

export const fetchTeamVoucherCampaignRate = () => {
  return dispatch => {
    orderService
      .getCampaignRate()
      .then(data =>
        dispatch(teamVoucherSetCampaignRate(data.filter(byChargeTypeCC)[0]))
      )
      .catch(error => console.error(error));
  };
};

export const openModalReceipt = () => dispatch => {
  dispatch(closeModalPlacedOrder());
  dispatch({
    type: actionTypes.TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT,
    payload: true
  });
};

export const closeModalReceiptAndRedirect = history => dispatch => {
  dispatch(teamVoucherResetState());
  history.replace("/Menu");
};

export const openModalConfirmEmails = () => dispatch => {
  dispatch({
    type: actionTypes.TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS,
    payload: false
  });
};

export const closeModalConfirmEmails = history => dispatch => {
  dispatch({
    type: actionTypes.TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS,
    payload: false
  });
};



// WEBPACK FOOTER //
// ./src/store/actions/TeamVoucher.js